/* eslint-disable no-undef */

import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import { apiMiddleware as reduxApiMiddleware } from 'redux-api-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './reducers/index';

export default function configureStore(initialState, history) {
  let finalCreateStore;

  if (__DEV__) {
    finalCreateStore = composeWithDevTools(
      applyMiddleware(require('redux-immutable-state-invariant')()),
      __BROWSER__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,
      applyMiddleware(thunk),
      applyMiddleware(reduxApiMiddleware),
    )(createStore);
  } else {
    finalCreateStore = compose(
      applyMiddleware(thunk),
      applyMiddleware(reduxApiMiddleware),
      __BROWSER__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,
    )(createStore);
  }

  const store = finalCreateStore(rootReducer(history), initialState);

  return store;
}
